/* Reserve the actual ripped-paper overlap on each side of a section boundary. */
(function () {
  'use strict';
  if (window.WillieDividerSpacing) return;

  var selector = '[data-divider-spacing-edge]';
  var managed = new Map();
  var ownStyles = new WeakMap();
  var observed = new Set();
  var pending = false;
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(refresh);
  }

  function visible(element) {
    var box = element.getBoundingClientRect();
    var style = getComputedStyle(element);
    return box.width > 0 && box.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function neighbour(section, direction) {
    for (var node = section[direction]; node; node = node[direction]) {
      if (!visible(node)) continue;
      return node.classList.contains('shopify-section') ? node : null;
    }
    return null;
  }

  function original(element, property) {
    var entry = managed.get(element);
    if (entry && entry[property]) return entry[property];
    return {
      value: element.style.getPropertyValue(property),
      priority: element.style.getPropertyPriority(property),
      fallback: getComputedStyle(element).getPropertyValue(property).trim() || '0px'
    };
  }

  function restore(element, property, entry) {
    if (entry.value) element.style.setProperty(property, entry.value, entry.priority);
    else element.style.removeProperty(property);
    ownStyles.set(element, element.getAttribute('style'));
  }

  function refresh() {
    pending = false;
    var plan = new Map();
    var watch = new Set();

    function reserve(element, edge, pixels, replace) {
      var property = '--shape-divider-pad-' + edge;
      var entry = plan.get(element) || {};
      var current = entry[property];
      entry[property] = {
        pixels: Math.max(current ? current.pixels : 0, pixels),
        replace: replace || (current && current.replace)
      };
      plan.set(element, entry);
      watch.add(element);
    }

    document.querySelectorAll(selector).forEach(function (divider) {
      var section = divider.closest('.shopify-section');
      var art = divider.querySelector('.shape-divider-svg-container');
      if (!section || !art) return;
      watch.add(section);
      watch.add(art);
      if (!visible(section) || !visible(art)) return;
      var above = divider.getAttribute('data-divider-spacing-edge') === 'above';
      var sectionBox = section.getBoundingClientRect();
      var artBox = art.getBoundingClientRect();
      if (divider.getAttribute('data-divider-spacing-owner') !== 'false') {
        var inside = above ? artBox.bottom - sectionBox.top : sectionBox.bottom - artBox.top;
        reserve(section, above ? 'top' : 'bottom', Math.max(0, inside), true);
      }
      var adjacent = neighbour(section, above ? 'previousElementSibling' : 'nextElementSibling');
      if (!adjacent) return;
      var adjacentBox = adjacent.getBoundingClientRect();
      var overlap = above ? adjacentBox.bottom - artBox.top : artBox.bottom - adjacentBox.top;
      if (overlap > 0) reserve(adjacent, above ? 'bottom' : 'top', overlap, false);
    });

    managed.forEach(function (entry, element) {
      Object.keys(entry).forEach(function (property) {
        if (!plan.has(element) || !plan.get(element)[property]) {
          restore(element, property, entry[property]);
          delete entry[property];
        }
      });
      if (!Object.keys(entry).length) managed.delete(element);
    });
    plan.forEach(function (properties, element) {
      var entry = managed.get(element) || {};
      Object.keys(properties).forEach(function (property) {
        var item = properties[property];
        var baseline = original(element, property);
        var size = Math.round(item.pixels * 1000) / 1000 + 'px';
        var fallback = baseline.fallback === '0' ? '0px' : baseline.fallback;
        var value = item.replace ? size : 'max(' + fallback + ', ' + size + ')';
        entry[property] = baseline;
        if (element.style.getPropertyValue(property) !== value) element.style.setProperty(property, value);
      });
      managed.set(element, entry);
      ownStyles.set(element, element.getAttribute('style'));
    });
    if (resizeObserver) {
      observed.forEach(function (element) { if (!watch.has(element)) resizeObserver.unobserve(element); });
      watch.forEach(function (element) { if (!observed.has(element)) resizeObserver.observe(element); });
      observed = watch;
    }
  }

  new MutationObserver(function (records) {
    if (records.some(function (record) {
      if (record.attributeName === 'style' && ownStyles.has(record.target) &&
          ownStyles.get(record.target) === record.target.getAttribute('style')) return false;
      if (record.type === 'childList') {
        return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
          return node.nodeType === 1 && (node.matches('.shopify-section, ' + selector) || node.querySelector(selector));
        });
      }
      return record.target === document.documentElement || record.target.matches('.shopify-section, ' + selector);
    })) schedule();
  }).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'data-active-line', 'data-divider-spacing-edge', 'data-divider-spacing-owner']
  });
  window.addEventListener('resize', schedule);
  document.addEventListener('line:change', schedule);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (event) {
    document.addEventListener(event, schedule);
  });
  if (document.fonts) {
    document.fonts.ready.then(schedule);
    document.fonts.addEventListener('loadingdone', schedule);
  }
  window.WillieDividerSpacing = { refresh: schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
